export default "__VITE_ASSET__9PO7vHFi__"